import { useState } from 'react';
import {
  Button,
  Group,
  Modal,
  Select,
  Stack,
  Text,
  Textarea,
} from '@mantine/core';
import {
  REJECTION_REASON_OPTIONS,
  buildRejectReason,
} from '../constants/rejectionReasons.ts';
import type { RejectionReasonCode } from '../constants/rejectionReasons.ts';

type RejectConfirmModalProps = {
  opened: boolean;
  accountLabel: string;
  documentTypeLabel: string;
  isPending: boolean;
  onCancel: () => void;
  onConfirm: (reason: string) => void;
};

const RejectConfirmModal = ({
  opened,
  accountLabel,
  documentTypeLabel,
  isPending,
  onCancel,
  onConfirm,
}: RejectConfirmModalProps) => {
  const [reasonCode, setReasonCode] = useState<RejectionReasonCode | null>(
    null,
  );
  const [note, setNote] = useState('');

  const isNoteRequired = reasonCode === 'OTHER';
  const canConfirm = Boolean(reasonCode) && (!isNoteRequired || note.trim());

  const handleCancel = () => {
    setReasonCode(null);
    setNote('');
    onCancel();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleCancel}
      title="確認審核失敗"
      centered
      keepMounted
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      <Stack gap="md">
        <Text size="sm">
          確定將 {accountLabel} 的{documentTypeLabel}標記為「審核失敗」？
        </Text>

        <Select
          label="失敗原因"
          placeholder="請選擇失敗原因"
          data={REJECTION_REASON_OPTIONS}
          value={reasonCode}
          onChange={(value) => setReasonCode(value as RejectionReasonCode)}
          withAsterisk
        />

        {isNoteRequired && (
          <Textarea
            label="原因說明"
            placeholder="請輸入退回原因，此內容會直接顯示給用戶，請注意用詞！"
            autosize
            minRows={2}
            value={note}
            onChange={(event) => setNote(event.currentTarget.value)}
            withAsterisk
          />
        )}
      </Stack>

      <Group justify="flex-end" mt="lg">
        <Button variant="outline" onClick={handleCancel} disabled={isPending}>
          取消
        </Button>
        <Button
          disabled={!canConfirm}
          loading={isPending}
          onClick={() => onConfirm(buildRejectReason(reasonCode!, note))}
        >
          確認
        </Button>
      </Group>
    </Modal>
  );
};

export { RejectConfirmModal };
